import { useEffect, useState } from "react";
import { useErrorSuccess } from "../../../../../hooks/useErrorSuccess";
import { T_Evento } from "../../../../../components/selects/celula";
import { useParams } from "react-router-dom";
import api from "../../../../../utils/api";

export type ResponseServiceEdit = {
  celula: T_Evento|undefined;
  cadastrarCelula: VoidFunction;
  changeCampusCelula: (campo: keyof T_Evento, valor: any | null) => void;
  isError: T_Evento
};

export const ServicesEdit = (): ResponseServiceEdit => {
  const [celula, setCelula] = useState<T_Evento>();

  const [isErrorActive, setErrorActive] = useState<T_Evento>();

  const { setErrorSuccess } = useErrorSuccess();

  const { id: idcelula } = useParams();


  const getEvent = async () => {
      try {
        const req = await api.get('evento/geral/'+idcelula);
        const res = req.data;
        setErrorActive(undefined);
        setCelula(res);
        return;
      } catch(error: any) {
        setErrorSuccess({
          mensagem: JSON.stringify(error?.response.data?.mensagem || 'Error', null, 2),
          status: 'error'
        });
        return;
      }
  }

  useEffect(() => {
  if(!parseInt(idcelula)) {
    setErrorSuccess({
      status: 'error',
      mensagem: 'Tipo informando não é um inteiro!'
    });

  return;
  } else {
    getEvent();
  }
  }, [])

  const cadastrarCelula = async () => {
    try {
      const req = await api.put(`evento/geral/${celula?.id}`, celula);
      const res = req?.data;

      setErrorSuccess({ mensagem: 'Celula Atualizada', status: 'success' })
    } catch(error) {
      if(!error?.response?.data?.mensagem) {
        if(!celula?.cep) {
          setErrorActive((value) => ({...value, cep: 'cep não passado!'}));
        }
        if(!celula?.inicio) {
          setErrorActive((value) => ({...value, inicio: 'Data inicío não passado!'}));
        }
        if(!celula?.fim) {
          setErrorActive((value) => ({...value, fim: 'Data Fim não passado!'}));
        }
        if(!celula?.bairro) {
          setErrorActive((value) => ({...value, bairro: 'Bairro não passado!'}));
        }
        if(!celula?.rua) {
          setErrorActive((value) => ({...value, rua: 'Rua não passado!'}));
        }
        if(!celula?.descricao) {
          setErrorActive((value) => ({...value, descricao: 'Nome do evento não passado!'}));
        }
        if(!celula?.whatsapp) {
          setErrorActive((value) => ({...value, whatsapp: 'Whatsapp não passado!'}));
        }
        if(!celula?.celula) {
          setErrorActive((value) => ({...value, celula: 'PG não passado!'}));
        }
        return;
      };

      setErrorSuccess({ mensagem: JSON.stringify(error?.response?.data?.mensagem, null, 2), status: 'error' })
    }
  };

  const changeCampusCelula = (campo: keyof T_Evento, value: any | null) =>
    setCelula(
      (valor: any) => ({ ...valor, [campo]: value })
    )


  return {
    celula,
    cadastrarCelula,
    changeCampusCelula,
    isError: isErrorActive
  }
};
